<template>
  <div>
    <group-card title="DocuSign Role List" icon="people" padded>
      <template slot="actions">
        <md-button
          @click="openNewRole"
          class="md-icon-button md-primary md-simple new-app-button"
        >
          <md-icon id="new-app-icon">note_add</md-icon>
          New DocuSign Role
          <md-tooltip md-direction="top">Add new DocuSign role</md-tooltip>
        </md-button>
        <loading-icon-button
          @click="refreshRoles(true)"
          tooltip="Refresh"
          :loading="progress_indicator.role_list"
        >
          refresh
        </loading-icon-button>
      </template>
      <!-- Role Details Editor -->
      <md-dialog :md-active.sync="show.edit_role_dialog">
        <md-dialog-title>
          {{ edit_role.id ? "Edit" : "New" }} DocuSign Role
        </md-dialog-title>
        <div class="md-layout">
          <!-- DocuSign Role Name -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-40"
            label="DocuSign Role Name"
            v-model="edit_role.docusign_rolename"
            required
          />
          <!-- Zink Name -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-30"
            label="Zink Name"
            v-model="edit_role.zink_name"
            required
          />
          <!-- Zink Email -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-30"
            label="Zink Email"
            v-model="edit_role.zink_email"
            required
          />
        </div>
        <md-dialog-actions>
          <md-button class="md-primary md-simple" @click="onCancel">
            Cancel
          </md-button>
          <md-button class="md-primary" @click="saveRole">
            {{ edit_role.id ? "Update" : "Save" }}
          </md-button>
        </md-dialog-actions>
      </md-dialog>
      <!-- Role Listing Table -->
      <RoleList
        :items="roles"
        :loading="progress_indicator.role_list"
        @open-role="openRole"
        @delete-role-clicked="deleteRole"
      >
      </RoleList>
    </group-card>
  </div>
</template>
<script>
import { GroupCard } from "@/components";
import { mapGetters } from "vuex";
import LoadingIconButton from "@/components/LoadingIconButton";
import ValidatedInputs from "@/components/ValidatedInput";
import RoleList from "../components/DocuSignRoleList.vue";
import axios from "axios";
export default {
  components: {
    GroupCard,
    LoadingIconButton,
    ...ValidatedInputs,
    RoleList,
  },
  data() {
    return {
      roles: [],
      show: {
        title: null,
        edit_role_dialog: false,
      },
      progress_indicator: {
        role_list: false,
        edit_role_id: false,
        remove_role_id: false,
      },
      edit_role: {
        id: null,
        docusign_rolename: null,
        zink_name: null,
        zink_email: null,
      },
      error_dialog: {
        show: false,
        title: null,
        content: null,
      },
    };
  },
  mounted() {
    this.refreshRoles();
  },
  methods: {
    async refreshRoles(force = false) {
      this.progress_indicator.role_list = true;
      await this.getRoles(force);
      this.progress_indicator.role_list = false;
    },
    async openRole(role) {
      this.setRole(role);
      this.show.title = "Edit DocuSign Role";
      this.show.edit_role_dialog = true;
      this.progress_indicator.edit_role_id = null;
    },
    async saveRole() {
      if (
        !this.edit_role.docusign_rolename ||
        !this.edit_role.zink_name ||
        !this.edit_role.zink_email
      ) {
        this.showDialog("Error", "Please fill all required fields.");
        return;
      }
      try {
        let response;
        response = await axios.post("/api/v1/docusign_roles", this.edit_role);
        if (response.status === 200) {
          const updatedRole = response.data;
          if (this.edit_role.id) {
            const index = this.roles.findIndex(
              (role) => role.id === updatedRole.id
            );
            if (index !== -1) {
              this.roles.splice(index, 1, updatedRole);
            }
          } else {
            this.roles.push(updatedRole);
          }
          this.show.edit_role_dialog = false;
        } else {
          console.error(
            "Error saving role. Unexpected status code:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error saving role:", error);
        this.showDialog("Error", "An error occurred while saving the role.");
      }
    },
    onCancel() {
      this.show.edit_role_dialog = false;
    },
    openNewRole() {
      this.edit_role = {
        id: null,
        docusign_rolename: "",
        zink_name: "",
        zink_email: "",
      };
      this.show.title = "Add New DocuSign Role";
      this.show.edit_role_dialog = true;
    },
    async getRoles(force = false) {
      try {
        const response = await axios.get("/api/v1/docusign_roles");
        if (response.status === 200) {
          this.roles = response.data;
        } else {
          console.error(
            "Error fetching roles. Unexpected status code:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    },

    async deleteRole(id) {
      try {
        this.progress_indicator.remove_role_id = id;
        await axios.delete(`/api/v1/docusign_roles/${id}`);
        this.roles = this.roles.filter((role) => role.id !== id);
        this.progress_indicator.remove_role_id = null;
      } catch (error) {
        console.error("Error deleting role:", error);
      }
    },
    setRole(role) {
      this.edit_role = {
        id: role.id,
        docusign_rolename: role.docusign_rolename,
        zink_name: role.zink_name,
        zink_email: role.zink_email,
      };
    },
  },

  resetRole() {
    this.edit_role = {
      id: null,
      docusign_rolename: null,
      zink_name: null,
      zink_email: null,
    };
  },
  showDialog(title, content) {
    this.error_dialog.title = title;
    this.error_dialog.content = content;
    this.error_dialog.show = true;
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";
@import "../assets/scss/md-custom/_ausloans-colors.scss";

md-dialog {
  overflow: scroll;
}

.sub-header {
  background-color: $ausloans-blue-light !important;
  border-radius: 5px;
  margin-bottom: 15px;
  color: white;
}

.co-branding {
  margin: 20px 0px;
}
</style>
